import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Modal from 'react-modal';
import './Catalog.css';

Modal.setAppElement('#root');

const Catalog = () => {
  const [fabrics, setFabrics] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('');
  const [selectedFabric, setSelectedFabric] = useState(null);
  const [selectedDesignIndex, setSelectedDesignIndex] = useState(0);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    const fetchFabrics = async () => {
      try {
        const response = await axios.get('http://localhost:5002/api/fabrics');
        setFabrics(response.data);
        const uniqueCategories = [...new Set(response.data.flatMap(fabric => fabric.categories || []))];
        setCategories(uniqueCategories);
      } catch (error) {
        console.error('Error fetching fabrics:', error);
      }
    };
    fetchFabrics();
  }, []);

  const handleCategoryChange = (e) => {
    setSelectedCategory(e.target.value);
  };

  const handleCardClick = (fabric) => {
    setSelectedFabric(fabric);
    setSelectedDesignIndex(0);
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
    setSelectedFabric(null);
  };

  const handleDesignChange = (index) => {
    setSelectedDesignIndex(index);
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  const filteredFabrics = fabrics.filter((fabric) => {
    const searchMatch = fabric.fabricName.toLowerCase().includes(searchQuery.toLowerCase());
    const categoryMatch = selectedCategory ? fabric.categories.includes(selectedCategory) : true;
    return searchMatch && categoryMatch;
  });

  return (
    <div className="catalog-container">
      <header className="catalog-header">
        <h1>Fabric Catalog</h1>
        <div className="search-and-filter">
          <input
            type="search"
            value={searchQuery}
            onChange={handleSearch}
            placeholder="Search fabrics"
            className="search-input"
          />
          <select onChange={handleCategoryChange} value={selectedCategory} className="category-dropdown">
            <option value="">All Categories</option>
            {categories.map((category, index) => (
              <option key={index} value={category}>
                {category}
              </option>
            ))}
          </select>
        </div>
      </header>

      <div className="fabric-grid">
        {filteredFabrics.map((fabric) => (
          <div
            key={fabric._id}
            className="fabric-card"
            onClick={() => handleCardClick(fabric)}
          >
            <img
              src={fabric.colorVariants[0]?.photos[0]}
              alt={fabric.fabricName}
              className="fabric-image"
            />
            <div className="fabric-info">
              <h2>{fabric.fabricName}</h2>
              <span className="variant-badge">{fabric.colorVariants.length} Designs</span>
            </div>
          </div>
        ))}
      </div>

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Fabric Details"
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        {selectedFabric && (
          <div className="modal-grid">
            {/* Left Image */}
            <div className="modal-image-container">
              <img
                src={selectedFabric.colorVariants[selectedDesignIndex]?.photos[0]}
                alt={selectedFabric.fabricName}
                className="modal-fabric-image"
              />
            </div>
            {/* Right Details */}
            <div className="modal-details-container">
              <h1>{selectedFabric.fabricName}</h1>
              <p>Category: {selectedFabric.categories.join(', ')}</p>
              <p>Gramatura: {selectedFabric.gramatura} g/m²</p>
              <p>Width: {selectedFabric.width} cm</p>
              <p>Composition:</p>
              <ul>
                {selectedFabric.composition.map((material, index) => (
                  <li key={index}>
                    {material.material} ({material.percentage}%)
                  </li>
                ))}
              </ul>
              {/* Design variant buttons */}
              <div className="design-variant-buttons">
                {selectedFabric.colorVariants.map((variant, index) => (
                  <button
                    key={index}
                    className={`variant-button ${index === selectedDesignIndex ? 'active' : ''}`}
                    onClick={() => handleDesignChange(index)}
                  >
                    Design {index + 1}
                  </button>
                ))}
              </div>
            </div>
            <button onClick={closeModal} className="close-modal-button">X</button>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default Catalog;